// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__6yfuR","error":"Textarea_error__2RDjC","readonly":"Textarea_readonly__1Ra1e","disabled":"Textarea_disabled__1DB7u"};